/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Badge_TrainerInputs */

const en_hero_badge_trainer = /** @type {(inputs: Hero_Badge_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal training`)
};

const pl_hero_badge_trainer = /** @type {(inputs: Hero_Badge_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening personalny`)
};

/**
* | output |
* | --- |
* | "Personal training" |
*
* @param {Hero_Badge_TrainerInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_badge_trainer = /** @type {((inputs?: Hero_Badge_TrainerInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Badge_TrainerInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_hero_badge_trainer(inputs)
	return en_hero_badge_trainer(inputs)
});